import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getAllRows } from "../ReportElementHelper";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class VoterRegistrations extends Component {
  state = {
    recCount: 0,
    votersTables: [],
    savedResultID: "",
    internalID: "",
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    const votersTables = [];
    let recCount = 0;
    const { isSilverReport } = this.props;
    if (props.reportData !== undefined) {
      const voterRegistrationNodes = isSilverReport
        ? this.props.node
        : _.get(
            props.reportData,
            "personReport.compReportResponse[0].individual[0].voterRegistrations[0].voterRegistration"
          );
      if (voterRegistrationNodes) {
        _.forEach(voterRegistrationNodes, (record, index) => {
          const recs = [];
          getAllRows(record, recs, props, _.get(record, "$.display"));
          if (recs.length > 0) {
            votersTables.push(
              <Table.Row key={`voter_registration_${index}`}>
                <Table.Cell>
                  <Table>
                    <Table.Body>
                      <Table.Row>
                        <Table.HeaderCell
                          className="report-sub-sub-section-header text-center"
                          colSpan={2}
                        >
                          Voter Registration
                        </Table.HeaderCell>
                      </Table.Row>
                      {recs}
                    </Table.Body>
                  </Table>
                </Table.Cell>
              </Table.Row>
            );
          }
        });
        recCount = votersTables.length;
      } else {
        votersTables.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    } else {
      votersTables.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ recCount, votersTables });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Voter Registrations"}
        rows={
          this.state.recCount > 0 ? (
            <Table.Row>
              <Table.Cell>
                <Table>
                  <Table.Body>{this.state.votersTables}</Table.Body>
                </Table>
              </Table.Cell>
            </Table.Row>
          ) : (
            this.state.votersTables
          )
        }
      />
    );
  }
}

export default VoterRegistrations;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/VoterRegistrations.js